import { NavContext } from "@ionic/react"
import {
  AuthResponse,
  DepartmentsResponse,
  DocumentsResponse,
  EmployeesResponse,
  EmployeeResponse,
  ProfileResponse,
  OccurrenceResponse,
} from "./../helpers/API"
import storageHelper from "../helpers/storageHelper"
import {
  SET_APP_VERSION,
  USER_IS_LOGGED,
  LOGIN_FAILURE,
  PROFILE_GET_FAILURE,
  TOKEN_EXPIRED,
  LOGIN_ERROR_CLEAR,
  LOGOUT,
  PASSWORD_CHANGED,
  PASSWORD_CHANGE_FAILURE,
  DOCUMENTS_GET_SUCCESS,
  DOCUMENTS_CLEAR,
  DOCUMENTS_GET_FAILURE,
  DOCUMENT_GET_SUCCESS,
  DOCUMENT_GET_FAILURE,
  IS_LOADING,
  IS_LOADING_INFINITE_SCROLL,
  SEARCH_DOCUMENTS_GET_SUCCESS,
  EMPLOYEES_GET_SUCCESS,
  EMPLOYEE_GET_SUCCESS,
  SEARCH_EMPLOYEES_GET_SUCCESS,
  CONTACTS_CLEAR,
  CONTACTS_GET_FAILURE,
  DEPARTMENTS_GET_SUCCESS,
  DEPARTMENT_GET_SUCCESS,
  SEARCH_DEPARTMENTS_GET_SUCCESS,
  DEPARTMENT_CLEAR,
  EMPLOYEE_CLEAR,
  HOME_PAGE_NAVIGATION,
  PROFILE_GET_SUCCESS,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAILURE,
  EMPLOYEE_CHANGE_PICTURE,
  SCHEDULE_GET_OCCURRENCES,
  SCHEDULE_GET_OCCURRENCES_SUCCESS,
  SCHEDULE_GET_OCCURRENCES_FAILURE,
  SCHEDULE_SET_CURRENT_DAY,
  FILTER_OCCURRENCES_SET,
  FILTER_OCCURRENCES_RESET,
  NETWORK_ERROR_CLEAR,
} from "./actions"
import { Token } from "typescript"
import { act } from "react-dom/test-utils"
import { AppState, Document } from "../global"

interface SetAppVersion {
  type: typeof SET_APP_VERSION
  payload: ""
}

interface LoadingAction {
  type: typeof IS_LOADING
}
interface LoadingActionInfiniteScroll {
  type: typeof IS_LOADING_INFINITE_SCROLL
}
interface LoginSuccessAction {
  type: typeof USER_IS_LOGGED
  payload: { data: AuthResponse }
}

interface LoginFailureAction {
  type: typeof LOGIN_FAILURE
  payload: {}
  err: ""
}

interface ProfileSuccessAction {
  type: typeof PROFILE_GET_SUCCESS
  payload: ProfileResponse
}

interface ProfileFailureAction {
  type: typeof PROFILE_GET_FAILURE
  payload: Error
}

interface TokenExpiredAction {
  type: typeof TOKEN_EXPIRED
  payload: {}
  err: ""
}

interface LoginErrorMessageClearAction {
  type: typeof LOGIN_ERROR_CLEAR
}

interface LogoutAction {
  type: typeof LOGOUT
}

interface PasswordChangeAction {
  type: typeof PASSWORD_CHANGED
}
interface PasswordChangeFailureAction {
  type: typeof PASSWORD_CHANGE_FAILURE
}
interface DocumentsAction {
  type: typeof DOCUMENTS_GET_SUCCESS
  payload: DocumentsResponse
}
interface SearchDocumentsAction {
  type: typeof SEARCH_DOCUMENTS_GET_SUCCESS
  payload: Document[]
}

interface DocumentsFailureAction {
  type: typeof DOCUMENTS_GET_FAILURE
  payload: Error
}

interface DocumentsClear {
  type: typeof DOCUMENTS_CLEAR
}

interface DocumentGetSuccess {
  type: typeof DOCUMENT_GET_SUCCESS
}

interface DocumentFailureAction {
  type: typeof DOCUMENT_GET_FAILURE
  payload: Error
}

interface SearchEmployeesAction {
  type: typeof SEARCH_EMPLOYEES_GET_SUCCESS
  payload: DocumentsResponse
}

interface EmployeesSuccessAction {
  type: typeof EMPLOYEES_GET_SUCCESS
  payload: EmployeesResponse
}

interface EmployeeSuccessAction {
  type: typeof EMPLOYEE_GET_SUCCESS
  payload: EmployeeResponse
}

interface EmployeeClear {
  type: typeof EMPLOYEE_CLEAR
}
interface ContactsClearAction {
  type: typeof CONTACTS_CLEAR
}
interface ContactsFailureAction {
  type: typeof CONTACTS_GET_FAILURE
  payload: Error
}
interface NavigateHomeAction {
  type: typeof HOME_PAGE_NAVIGATION
}

interface DepartmentsSuccessAction {
  type: typeof DEPARTMENTS_GET_SUCCESS
  payload: DepartmentsResponse
}

interface DepartmentSuccessAction {
  type: typeof DEPARTMENT_GET_SUCCESS
  payload: DepartmentsResponse
}

interface SearchDepartmentsAction {
  type: typeof SEARCH_DEPARTMENTS_GET_SUCCESS
  payload: DocumentsResponse
}

interface DepartmentClear {
  type: typeof DEPARTMENT_CLEAR
}

interface ImageUploadSuccessAction {
  type: typeof UPLOAD_IMAGE_SUCCESS
}

interface ImageUploadFailureAction {
  type: typeof UPLOAD_IMAGE_FAILURE
}
interface SetEmployeePictureAction {
  type: typeof EMPLOYEE_CHANGE_PICTURE
  payload: string
}

interface OccurrencesSuccessAction {
  type: typeof SCHEDULE_GET_OCCURRENCES_SUCCESS
  payload: { data: OccurrenceResponse[] }
}

interface OccurrencesFailureAction {
  type: typeof SCHEDULE_GET_OCCURRENCES_FAILURE
  payload: Error
}

interface ScheduleSetCurrentDay {
  type: typeof SCHEDULE_SET_CURRENT_DAY
  payload: { data: Date }
}

interface FilterOccurrencesSet {
  type: typeof FILTER_OCCURRENCES_SET
  payload: { selectedOccurrences: OccurrenceResponse[]; selectedDate: Date }
}
interface FilterOccurrencesReset {
  type: typeof FILTER_OCCURRENCES_RESET
}

interface NetworkErrorMessageClearAction {
  type: typeof NETWORK_ERROR_CLEAR
}

type IpaddiActionTypes =
  | SetAppVersion
  | DocumentsAction
  | DocumentsClear
  | LoginSuccessAction
  | LoginFailureAction
  | ProfileSuccessAction
  | TokenExpiredAction
  | LoginErrorMessageClearAction
  | LogoutAction
  | PasswordChangeAction
  | PasswordChangeFailureAction
  | DocumentsFailureAction
  | DocumentGetSuccess
  | DocumentFailureAction
  | LoadingAction
  | LoadingActionInfiniteScroll
  | SearchDocumentsAction
  | EmployeesSuccessAction
  | EmployeeSuccessAction
  | EmployeeClear
  | ContactsClearAction
  | ContactsFailureAction
  | DepartmentsSuccessAction
  | DepartmentSuccessAction
  | DepartmentClear
  | SearchDepartmentsAction
  | SearchEmployeesAction
  | NavigateHomeAction
  | ImageUploadSuccessAction
  | ImageUploadFailureAction
  | SetEmployeePictureAction
  | OccurrencesSuccessAction
  | OccurrencesFailureAction
  | ScheduleSetCurrentDay
  | FilterOccurrencesSet
  | FilterOccurrencesReset
  | NetworkErrorMessageClearAction

const reducer = (state: AppState, action: IpaddiActionTypes) => {
  switch (action.type) {
    case SET_APP_VERSION:
      return { ...state, appVersion: action.payload }
    case IS_LOADING:
      return { ...state, isLoading: true }
    case IS_LOADING_INFINITE_SCROLL:
      return { ...state, isLoadingInfiniteScroll: true }
    case LOGOUT:
      storageHelper.putAccessToken(null)
      storageHelper.putRefreshToken(null)
      return {
        ...state,
        isLoggedIn: false,
      }
    case PASSWORD_CHANGED:
      console.log(`password_changed:${state}`)
      return {
        ...state,
        mustChangePassword: false,
        isLoggedIn: false,
      }
    case PASSWORD_CHANGE_FAILURE:
      return {
        ...state,
        // changePassword: false,
      }

    case LOGIN_FAILURE:
      return {
        ...state,
        loginErrorMessage: "Credenziali invalide.",
        isLoggedIn: false,
        isLoading: false,
      }

    case PROFILE_GET_SUCCESS:
      return {
        ...state,
        profile: action.payload,
      }

    case LOGIN_ERROR_CLEAR:
      return {
        ...state,
        loginErrorMessage: null,
      }
    case USER_IS_LOGGED:
      console.log("action payload", action?.payload)
      console.log("current state", state)
      let newstate = {
        ...state,
        mustChangePassword: action?.payload?.data?.must_change_password,
        loginErrorMessage: null,
        isLoggedIn: true,
        isLoading: false,
      }
      console.log("new state", newstate)
      return newstate
    case TOKEN_EXPIRED:
      return {
        ...state,
        isLoggedIn: false,
        isLoading: false,
      }

    //-------------DOCUMENTS----------------

    case DOCUMENTS_GET_SUCCESS:
      console.log("action.payload.next_link: ", action.payload.next_link)

      return {
        ...state,
        documents:
          action.payload.first === 1
            ? action.payload.results || []
            : (state.documents || []).concat(action.payload.results || []),
        nextPageUrl: action.payload.next_link,
        lastPageUrl: action.payload.last_link,
        isLoading: false,
        isLoadingInfiniteScroll: false,
      }
    case SEARCH_DOCUMENTS_GET_SUCCESS:
      return {
        ...state,
        documents: action.payload,
        nextPageUrl: "",
        lastPageUrl: "",
      }
    case DOCUMENTS_GET_FAILURE:
      console.log("documents error ")
      return {
        ...state,
        isLoading: false,
        isLoadingInfiniteScroll: false,
      }
    case DOCUMENTS_CLEAR:
      return {
        ...state,
        documents: [],
        nextPageUrl: "",
        lastPageUrl: "",
      }
    case DOCUMENT_GET_SUCCESS:
      console.log("Document downloaded")
      return {
        ...state,
        isLoading: false,
      }
    case DOCUMENT_GET_FAILURE:
      console.log("Document download failed")
      return {
        ...state,
        isLoading: false,
      }

    //-------------EMPLOYEES----------------

    case EMPLOYEES_GET_SUCCESS:
      return {
        ...state,
        employees:
          action.payload.first === 1
            ? action.payload.results || []
            : (state.employees || []).concat(action.payload.results || []),
        nextPageUrl: action.payload.next_link,
        lastPageUrl: action.payload.last_link,
        isLoading: false,
        isLoadingInfiniteScroll: false,
        networkErrorMessage: "",
      }

    case EMPLOYEE_GET_SUCCESS:
      return {
        ...state,
        employee: action.payload,
        isLoading: false,
      }

    case SEARCH_EMPLOYEES_GET_SUCCESS:
      console.log("action.payload.next_link: ", action.payload.next_link)
      return {
        ...state,
        employees: Array.isArray(action.payload)
          ? action.payload
          : action.payload.results || [],
        nextPageUrl: "",
        lastPageUrl: "",
        isLoading: false,
        isLoadingInfiniteScroll: false,
      }

    case EMPLOYEE_CHANGE_PICTURE:
      return {
        ...state,
        employee: { ...state.employee, picture: action.payload },
      }

    case EMPLOYEE_CLEAR:
      return {
        ...state,
        employee: null,
      }

    //-------------DEPARTMENTS----------------

    case DEPARTMENTS_GET_SUCCESS:
      return {
        ...state,
        departments:
          action.payload.first === 1
            ? action.payload.results || []
            : (state.departments || []).concat(action.payload.results || []),
        nextPageUrl: action.payload.next_link,
        lastPageUrl: action.payload.last_link,
        isLoading: false,
        isLoadingInfiniteScroll: false,
        networkErrorMessage: "",
      }

    case SEARCH_DEPARTMENTS_GET_SUCCESS:
      console.log("action.payload.next_link: ", action.payload.next_link)
      return {
        ...state,
        departments: Array.isArray(action.payload)
          ? action.payload
          : action.payload.results || [],
        nextPageUrl: "",
        lastPageUrl: "",
        isLoading: false,
        isLoadingInfiniteScroll: false,
      }

    case DEPARTMENT_GET_SUCCESS:
      return {
        ...state,
        department: action.payload,
        isLoading: false,
      }

    case DEPARTMENT_CLEAR:
      return {
        ...state,
        department: null,
      }

    //-------------IMAGE UPLOAD ----------------

    case UPLOAD_IMAGE_SUCCESS:
      return { ...state, isLoading: false }

    case UPLOAD_IMAGE_FAILURE:
      return { ...state, isLoading: false }

    case CONTACTS_CLEAR:
      return {
        ...state,
        departments: [],
        employees: [],
        nextPageUrl: "",
        lastPageUrl: "",
        networkErrorMessage: "",
      }

    case CONTACTS_GET_FAILURE:
      return {
        ...state,
        employees: state.employees || [],
        departments: state.departments || [],
        isLoading: false,
        isLoadingInfiniteScroll: false,
        networkErrorMessage: "Errore nel caricamento dei contatti.",
      }

    case HOME_PAGE_NAVIGATION:
      return {
        ...state,
        nextPageUrl: null,
        lastPageUrl: null,
        isLoading: false,
      }

    // ------- SCHEDULE ----------
    case SCHEDULE_GET_OCCURRENCES_SUCCESS:
      // this block is to handle the case in which
      // a user is on more than one group subscribed on a calendar
      // to avoid repetitions, we filter object
      // that have same start, end, calendar
      const ISO_8601 = /(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})(Z|[+-]\d{2}:\d{2})/

      const array = action.payload.data
      const data: OccurrenceResponse[] = [...array]

      array.forEach(function (occ: any, index: number) {
        Object.keys(occ).forEach(function (k) {
          //@ts-ignore
          if (ISO_8601.test(data[index][k])) {
            //@ts-ignore
            data[index][k] = new Date(Date.parse(data[index][k]))
          }
        })
      })

      //@ts-ignore
      const objToId = ({ id, start, end, calendar }) =>
        id || `${start}-${end}-${calendar}`
      const ids = array.map(objToId)
      const occurrences = array.filter(
        (item, index) => !ids.includes(objToId(item), index + 1)
      )

      return {
        ...state,
        occurrences: occurrences,
        // selecteselectedDatedOccurrences: action.payload.data,
      }
    case SCHEDULE_GET_OCCURRENCES_FAILURE:
      return {
        ...state,
        // React no pol renderizzare l'oggetto Error: tenemo solo testo umano.
        networkErrorMessage: "Errore nel caricamento del calendario.",
      }
    case FILTER_OCCURRENCES_SET:
      return {
        ...state,
        selectedOccurrences: action.payload.selectedOccurrences,
        // selectedDate: action.payload.selectedDate,
      }
    case FILTER_OCCURRENCES_RESET:
      return {
        ...state,
        selectedOccurrences: state.occurrences,
      }

    case SCHEDULE_SET_CURRENT_DAY:
      return {
        ...state,
        selectedDate: action.payload,
      }

    case NETWORK_ERROR_CLEAR:
      return {
        ...state,
        networkErrorMessage: "",
      }

    default:
      return state
  }
}

export default reducer
